import axios from 'axios'
import {
  getHeader,
  getOrganizationIdParamString,
  handleError,
  handleResponse
} from '@/helpers/api'
import store from '../store'
import {
  DocumentProductionStatus,
  DocumentValidationStatus,
  OrderStatus
} from '@/enums'

const apiDocumentsClient = axios.create({
  baseURL: `${window.config.VUE_APP_ORDER_API_BASE_URL}`,
  withCredentials: true
})

export const documentsService = {
  requestDocumentCancellation,
  cancelDocuments,
  getDocumentProductionStatus,
  getDocumentOrderStatus,
  deleteDocuments,
  canCancelDocuments,
  canDeleteDocuments
}

// API functions
function requestDocumentCancellation(documentIds) {
  return apiDocumentsClient
    .post(`/Document/request-cancellation`, { documentIds }, getHeader())
    .then(handleResponse)
    .catch(handleError)
}

function cancelDocuments(documentIds) {
  return apiDocumentsClient
    .post(
      `/Document/cancellation${getOrganizationIdParamString()}`,
      { documentIds },
      getHeader()
    )
    .then(handleResponse)
    .catch(handleError)
}

async function deleteDocuments(payload) {
  return apiDocumentsClient
    .delete('/Document/', {
      headers: {
        Authorization: 'bearer ' + store.getters.jwt
      },
      data: payload
    })
    .then(handleResponse)
    .catch(handleError)
}

function getDocumentProductionStatus(document, orders) {
  const ordersArray = Array.isArray(orders) ? orders : [orders]

  for (const order of ordersArray) {
    if (document?.orderId === order?.orderId) {
      for (const orderPosition of order?.orderPositions || []) {
        const matchedDocument = orderPosition?.documents?.find(
          opDoc => opDoc?.documentId === document?.documentId
        )
        if (matchedDocument) {
          return matchedDocument?.productionStatus
        }
      }
    }
  }
  return null
}

function getDocumentOrderStatus(document, orders) {
  const ordersArray = Array.isArray(orders) ? orders : [orders]

  for (const order of ordersArray) {
    if (document?.orderId === order?.orderId) {
      return order?.orderStatus
    }
  }
  return null
}

// Permissive functions
function canCancelDocuments(document, orders) {
  const productionStatus = this.getDocumentProductionStatus(document, orders)
  const orderStatus = this.getDocumentOrderStatus(document, orders)
  // // applies only for paid order, new documents & skipPayment (implies billing customers), as mentioned in #6089
  return (
    orderStatus === OrderStatus.paid ||
    (orderStatus === OrderStatus.partiallyCancelled &&
      productionStatus === DocumentProductionStatus.New &&
      store.getters.hasPermission('SkipPayment'))
  )
}

function canDeleteDocuments(validatedDocuments) {
  return (
    validatedDocuments.find(
      document => document.validationStatus === DocumentValidationStatus.Pending
    ) === undefined
  )
}
